/* ==========================================================================
   main.js — Cosmo JrTrack 5 PDP interactions
   Vanilla JS. No dependencies beyond Bootstrap's bundle (already loaded).
   ========================================================================== */
(function () {
  "use strict";

  if (window.__jtSeInit) return;
  window.__jtSeInit = true;

  /* ----------------------------------------------------- Star rendering */
  var STAR_FULL = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.8 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"/></svg>';
  var STAR_HALF = '<svg viewBox="0 0 24 24" fill="none"><defs><linearGradient id="h' + Math.random().toString(36).slice(2) + '"></linearGradient></defs><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.8 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z" fill="url(#half)"/></svg>';

  function renderStars(el) {
    var rating = parseFloat(el.getAttribute("data-rating")) || 0;
    var html = "";
    for (var i = 1; i <= 5; i++) {
      if (rating >= i) {
        html += '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.8 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"/></svg>';
      } else if (rating >= i - 0.5) {
        var id = "g" + Math.random().toString(36).slice(2);
        html += '<svg viewBox="0 0 24 24"><defs><linearGradient id="' + id + '"><stop offset="50%" stop-color="currentColor"/><stop offset="50%" stop-color="currentColor" stop-opacity="0.25"/></linearGradient></defs><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.8 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z" fill="url(#' + id + ')"/></svg>';
      } else {
        html += '<svg viewBox="0 0 24 24" fill="currentColor" opacity="0.25"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.8 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"/></svg>';
      }
    }
    el.innerHTML = html;
  }
  document.querySelectorAll("[data-rating]").forEach(renderStars);

  /* --------------------------------------------------- Product gallery */
  function bindGalleryThumbs(gallery) {
    var mainImg = gallery.querySelector("#gallery-main-img, .gallery-main__img");
    if (!mainImg) return;
    gallery.querySelectorAll(".gallery-thumb").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var src = btn.getAttribute("data-src");
        if (!src) return;
        gallery.querySelectorAll(".gallery-thumb").forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        mainImg.style.opacity = "0";
        setTimeout(function () {
          mainImg.src = src;
          mainImg.style.opacity = "1";
        }, 200);
      });
    });
  }
  document.querySelectorAll(".gallery-mobile").forEach(bindGalleryThumbs);

  /* ------------------------------------------------------ Color swatches */
  document.querySelectorAll(".swatches .swatch").forEach(function (sw) {
    if (sw.closest("[data-jt-se-hero-managed]")) return;
    sw.addEventListener("click", function () {
      document.querySelectorAll(".swatches .swatch").forEach(function (s) { s.classList.remove("is-active"); });
      sw.classList.add("is-active");
    });
  });

  /* --------------------------------------------------- Bundle + cart price */
  function setCartPrice(price, scope) {
    var root = scope || document;
    root.querySelectorAll("[data-cart-price]").forEach(function (n) {
      // Never overwrite hero-managed or page-wide watch ATC prices from generic bundles.
      if (n.hasAttribute("data-jt-se-cart-price")) return;
      if (n.closest("[data-jt-se-riskfree-atc], [data-jt-se-page-atc], [data-jt-se-atc]")) return;
      n.textContent = price;
    });
  }
  document.querySelectorAll(".bundle").forEach(function (b) {
    if (b.closest("[data-jt-se-hero-managed]")) return;
    b.addEventListener("click", function () {
      var groupRoot = b.closest(".bundles, [data-jt-se-bundles], section") || document;
      groupRoot.querySelectorAll(".bundle").forEach(function (x) { x.classList.remove("is-active"); });
      b.classList.add("is-active");
      var p = b.getAttribute("data-price");
      if (p) setCartPrice(p, groupRoot);
    });
  });

  /* ------------------------------------------------------ Info tabs (Benefits / Membership) */
  document.querySelectorAll("[data-jt-se-info-tabs]").forEach(function (tablist) {
    var root = tablist.closest("[data-jt-se-hero-managed]");
    if (!root) return;

    var tabs = tablist.querySelectorAll(".jt-se-info-tab");
    var benefitsPanel = root.querySelector('[id^="jt-se-tab-benefits-"]');
    var membershipPanel = root.querySelector('[id^="jt-se-tab-membership-"]');

    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t) {
          t.classList.remove("is-active");
          t.setAttribute("aria-selected", "false");
        });
        tab.classList.add("is-active");
        tab.setAttribute("aria-selected", "true");

        var showBenefits = index === 0;
        if (benefitsPanel) {
          benefitsPanel.hidden = !showBenefits;
          benefitsPanel.classList.toggle("jt-se-tab-panel--hidden", !showBenefits);
        }
        if (membershipPanel) {
          membershipPanel.hidden = showBenefits;
          membershipPanel.classList.toggle("jt-se-tab-panel--hidden", showBenefits);
        }
      });
    });
  });

  /* ------------------------------------------------------ Compare selector */
  document.addEventListener('click', function (event) {
    var cmpOpt = event.target.closest('.cmp-selector__opt');
    if (cmpOpt) {
      var cmpSelector = cmpOpt.closest('.cmp-selector');
      if (!cmpSelector) return;
      var col = parseInt(cmpOpt.dataset.col, 10);
      var cmpSelectorBtn = cmpSelector.querySelector('.cmp-selector__btn');
      var cmpSelectorLabel = cmpSelector.querySelector('[data-cmp-selector-label]');

      cmpSelector.querySelectorAll('.cmp-selector__opt').forEach(function (opt) {
        opt.classList.remove('is-active');
      });
      cmpOpt.classList.add('is-active');

      if (cmpSelectorLabel) cmpSelectorLabel.textContent = cmpOpt.textContent.trim();

      var compareSection = cmpSelector.closest('.compare-section');
      var scope = compareSection || document;

      if (col === 3) {
        scope.querySelectorAll('.cmp-cell:nth-child(3)').forEach(function (cell) { cell.style.display = 'flex'; });
        scope.querySelectorAll('.cmp-cell:nth-child(4)').forEach(function (cell) { cell.style.display = 'none'; });
      } else {
        scope.querySelectorAll('.cmp-cell:nth-child(4)').forEach(function (cell) { cell.style.display = 'flex'; });
        scope.querySelectorAll('.cmp-cell:nth-child(3)').forEach(function (cell) { cell.style.display = 'none'; });
      }

      cmpSelector.classList.remove('is-open');
      if (cmpSelectorBtn) cmpSelectorBtn.setAttribute('aria-expanded', 'false');
      return;
    }

    var cmpSelectorBtn = event.target.closest('.cmp-selector__btn');
    if (cmpSelectorBtn) {
      var selector = cmpSelectorBtn.closest('.cmp-selector');
      if (!selector) return;
      var isOpen = selector.classList.toggle('is-open');
      cmpSelectorBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    document.querySelectorAll('.cmp-selector.is-open').forEach(function (selector) {
      if (!selector.contains(event.target)) {
        selector.classList.remove('is-open');
        var btn = selector.querySelector('.cmp-selector__btn');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ---------------------------------------------------- Reviews "More" */
  document.querySelectorAll("[data-rev-more]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var body = btn.previousElementSibling;
      if (!body) return;
      var open = body.classList.toggle("is-open");
      var labelNode = btn.childNodes[btn.childNodes.length - 1];
      if (labelNode && labelNode.nodeType === 3) {
        labelNode.textContent = open ? " Less" : " More";
      }
      var icon = btn.querySelector("svg");
      if (icon) icon.style.transform = open ? "rotate(180deg)" : "";
    });
  });

  /* ------------------------------------------------------------- Tabs */
  var FEATURES = [
    { eyebrow: "Emergency", title: "SOS your kid actually understands.", desc: "Hold the side button 3 seconds. The watch calls your primary contact and shares live location.", img: "images/c-watch-slider-1.png" },
    { eyebrow: "Tracking", title: "See where they are, live.", desc: "Real-time location on the map, refreshed every few seconds while they're on the move — no refresh button required.", img: "images/c-watch-slider-2.png" },
    { eyebrow: "Coverage", title: "HaloGPS multi-network coverage.", desc: "Combines GPS, Wi-Fi and cell triangulation across multiple carriers so the dot stays accurate indoors and out.", img: "images/c-watch-slider-3.png" },
    { eyebrow: "Safety", title: "Only people you approve.", desc: "You build the contact list in the Cosmo App. No unknown numbers, no open inbox, no strangers.", img: "images/c-watch-slider-4.png" }
  ];
  var APP = [
    { title: "SafeZones & alerts", desc: "Draw a zone around school. Get notified when they arrive — and when they leave." },
    { title: "Approve every contact", desc: "Add, remove and reorder who can reach the watch — all from your phone, anytime." },
    { title: "School Mode schedule", desc: "Mute non-emergency features during class hours automatically, on the days you set." },
    { title: "Live location & history", desc: "See current location and a breadcrumb trail of where they've been through the day." }
  ];

  var TAB_DURATION = 8000;

  function createRingSVG() {
    var size = 60, sw = 3, r = (size / 2) - sw / 2;
    var circ = parseFloat((2 * Math.PI * r).toFixed(3));
    var ns = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(ns, "svg");
    svg.setAttribute("class", "content-ring");
    svg.setAttribute("viewBox", "0 0 " + size + " " + size);
    svg.setAttribute("width", size);
    svg.setAttribute("height", size);
    var fill = document.createElementNS(ns, "circle");
    fill.setAttribute("cx", size / 2);
    fill.setAttribute("cy", size / 2);
    fill.setAttribute("r", r);
    fill.setAttribute("class", "ring-fill");
    fill.setAttribute("stroke-dasharray", circ);
    fill.setAttribute("stroke-dashoffset", circ);
    svg.appendChild(fill);
    return { svg: svg, fill: fill, circ: circ };
  }

  function bindTabs(group, data, apply) {
    var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-tabs="' + group + '"] .tab'));
    if (!tabs.length) return;

    var panel = document.querySelector('[data-panel="' + group + '"]');
    if (panel) panel.style.transition = "opacity .18s ease";

    var ring = createRingSVG();
    var numEl = panel && panel.querySelector(".showcase__num");
    if (numEl) numEl.appendChild(ring.svg);

    var autoTimer = null;
    var currentIdx = 0;

    function startRing() {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ring.fill.style.transition = "stroke-dashoffset " + TAB_DURATION + "ms linear";
          ring.fill.style.strokeDashoffset = "0";
        });
      });
    }

    function resetRing() {
      ring.fill.style.transition = "none";
      ring.fill.style.strokeDashoffset = String(ring.circ);
    }

    function activateTab(idx, skipFade) {
      clearTimeout(autoTimer);
      resetRing();

      tabs.forEach(function (t) { t.classList.remove("is-active"); });
      tabs[idx].classList.add("is-active");
      currentIdx = idx;

      if (tabContainer) {
        var activeTab = tabs[idx];
        var tabLeft = activeTab.offsetLeft;
        var tabRight = tabLeft + activeTab.offsetWidth;
        var containerScrollLeft = tabContainer.scrollLeft;
        var containerWidth = tabContainer.offsetWidth;
        if (tabLeft < containerScrollLeft) {
          tabContainer.scrollTo({ left: tabLeft - 16, behavior: "smooth" });
        } else if (tabRight > containerScrollLeft + containerWidth) {
          tabContainer.scrollTo({ left: tabRight - containerWidth + 16, behavior: "smooth" });
        }
      }

      var watchImg = panel && panel.parentElement && panel.parentElement.querySelector(".showcase__watch-img");

      if (panel && !skipFade) {
        panel.style.opacity = "0";
        if (watchImg) watchImg.style.opacity = "0";
        setTimeout(function () {
          apply(data[idx], panel);
          panel.style.opacity = "1";
          if (watchImg) watchImg.style.opacity = "1";
          startRing();
        }, 160);
      } else {
        startRing();
      }

      autoTimer = setTimeout(function () {
        activateTab((currentIdx + 1) % tabs.length, false);
      }, TAB_DURATION);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener("click", function () { activateTab(i, false); });
    });

    var tabContainer = document.querySelector('[data-tabs="' + group + '"]');
    var ioTab = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        activateTab(0, true);
        ioTab.disconnect();
      }
    }, { threshold: 0.3 });
    if (tabContainer) ioTab.observe(tabContainer);
  }

  bindTabs("features", FEATURES, function (d, panel) {
    if (!panel || !d) return;
    var e = panel.querySelector("[data-f-eyebrow]"); if (e) e.textContent = d.eyebrow;
    var title = panel.querySelector("[data-f-title]"); if (title) title.textContent = d.title;
    var desc = panel.querySelector("[data-f-desc]"); if (desc) desc.textContent = d.desc;
    var watchImg = panel.parentElement && panel.parentElement.querySelector(".showcase__watch-img");
    if (watchImg && d.img) watchImg.src = d.img;
  });
  bindTabs("app", APP, function (d, panel) {
    if (!panel || !d) return;
    var title = panel.querySelector("[data-a-title]"); if (title) title.textContent = d.title;
    var desc = panel.querySelector("[data-a-desc]"); if (desc) desc.textContent = d.desc;
  });

  /* ------------------------------------------------ Moments carousel */
  document.querySelectorAll("[data-moments]").forEach(function (track) {
    if (track.closest(".sl-section.moments-section")) return;
    if (track.dataset.momentsInit === "true") return;
    track.dataset.momentsInit = "true";

    var section = track.closest(".moments-section");
    var prev = section ? section.querySelector("[data-moments-prev]") : null;
    var next = section ? section.querySelector("[data-moments-next]") : null;
    var autoTimer = null;
    var mobileMomentsQuery = window.matchMedia("(max-width: 991.98px)");

    function isMobileMomentsLayout() {
      return mobileMomentsQuery.matches;
    }

    function getGap() {
      var gap = parseFloat(getComputedStyle(track).gap);
      return isNaN(gap) ? 31 : gap;
    }

    function getOriginalCards() {
      return Array.prototype.slice.call(track.querySelectorAll(".moment:not([data-moment-clone])"));
    }

    function ensureLoopClones() {
      if (track.dataset.momentsCloned === "true") return;
      var originals = getOriginalCards();
      if (!originals.length) return;

      originals.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute("data-moment-clone", "true");
        clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
      });

      track.dataset.momentsCloned = "true";
    }

    function removeLoopClones() {
      track.querySelectorAll(".moment[data-moment-clone]").forEach(function (clone) {
        clone.remove();
      });
      delete track.dataset.momentsCloned;
    }

    function cardStep() {
      var originals = getOriginalCards();
      var card = originals[0] || track.querySelector(".moment");
      return card ? card.offsetWidth + getGap() : track.clientWidth / 3;
    }

    function loopWidth() {
      return getOriginalCards().length * cardStep();
    }

    function normalizeScrollPosition() {
      var width = loopWidth();
      if (width <= 0) return;
      if (track.scrollLeft >= width) {
        track.scrollLeft -= width;
      } else if (track.scrollLeft < 0) {
        track.scrollLeft += width;
      }
    }

    function scrollToOffset(targetLeft, smooth) {
      track.scrollTo({ left: targetLeft, behavior: smooth ? "smooth" : "auto" });
    }

    function scrollNext() {
      if (isMobileMomentsLayout()) return;
      ensureLoopClones();
      var width = loopWidth();
      if (!width) return;

      var step = cardStep();
      var nextLeft = track.scrollLeft + step;

      if (nextLeft >= width) {
        scrollToOffset(nextLeft - width, false);
        requestAnimationFrame(function () {
          scrollToOffset(track.scrollLeft + step, true);
        });
        return;
      }

      scrollToOffset(nextLeft, true);
    }

    function scrollPrev() {
      if (isMobileMomentsLayout()) return;
      ensureLoopClones();
      var width = loopWidth();
      if (!width) return;

      var step = cardStep();
      var nextLeft = track.scrollLeft - step;

      if (nextLeft < 0) {
        scrollToOffset(width, false);
        requestAnimationFrame(function () {
          scrollToOffset(width - step, true);
        });
        return;
      }

      scrollToOffset(nextLeft, true);
    }

    function startAuto() {
      if (autoTimer || isMobileMomentsLayout()) return;
      autoTimer = setInterval(scrollNext, 5000);
    }

    function stopAuto() {
      clearInterval(autoTimer);
      autoTimer = null;
    }

    function resetAuto() {
      stopAuto();
      startAuto();
    }

    track.addEventListener("scroll", function () {
      if (isMobileMomentsLayout()) return;
      window.requestAnimationFrame(normalizeScrollPosition);
    }, { passive: true });

    if (next) next.addEventListener("click", function () { stopAuto(); scrollNext(); resetAuto(); });
    if (prev) prev.addEventListener("click", function () { stopAuto(); scrollPrev(); resetAuto(); });

    track.addEventListener("mouseenter", stopAuto);
    track.addEventListener("mouseleave", startAuto);
    track.addEventListener("touchstart", stopAuto, { passive: true });
    track.addEventListener("touchend", function () { setTimeout(startAuto, 2000); }, { passive: true });

    mobileMomentsQuery.addEventListener("change", function () {
      if (isMobileMomentsLayout()) {
        stopAuto();
        track.scrollLeft = 0;
        removeLoopClones();
      } else {
        ensureLoopClones();
        startAuto();
      }
    });

    if (isMobileMomentsLayout()) {
      removeLoopClones();
    } else {
      ensureLoopClones();
      startAuto();
    }
  });

  /* -------------------------------------------------- Press logo carousel */
  document.querySelectorAll("[data-press-track]").forEach(function (track) {
    var autoTimer = null;
    var pressSection = track.closest(".press-section");
    var pressWrap = track.closest(".press__track-wrap");

    function getPressGap() {
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.gap);
      if (!isNaN(gap) && gap > 0) return gap;
      return parseFloat(styles.columnGap) || 32;
    }

    function getVisibleColumns() {
      var visible = pressWrap && pressWrap.getAttribute("data-press-visible");
      if (visible) return parseInt(visible, 10) || 6;
      if (pressSection) {
        var columns = parseInt(getComputedStyle(pressSection).getPropertyValue("--press-columns"), 10);
        if (!isNaN(columns) && columns > 0) return columns;
      }
      return 6;
    }

    function getItemCount() {
      var total = pressWrap && pressWrap.getAttribute("data-press-total");
      if (total) return parseInt(total, 10) || track.querySelectorAll(".press__item").length;
      return track.querySelectorAll(".press__item").length;
    }

    function needsCarousel() {
      return getItemCount() > getVisibleColumns();
    }

    function itemStep() {
      var item = track.querySelector(".press__item");
      return item ? item.offsetWidth + getPressGap() : track.clientWidth / getVisibleColumns();
    }

    function canScroll() {
      if (!needsCarousel()) return false;
      return track.scrollWidth > track.clientWidth + 2;
    }

    function updateTrackState() {
      var wrap = track.closest(".press__track-wrap");
      var scrollable = needsCarousel();
      if (wrap) {
        wrap.classList.toggle("press__track-wrap--scrollable", scrollable);
      }
      track.classList.toggle("press__track--scrollable", scrollable);
      if (!scrollable) {
        track.scrollLeft = 0;
        stopAuto();
      } else if (!autoTimer) {
        startAuto();
      }
    }

    function scrollNext() {
      if (!needsCarousel()) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return;
      if (track.scrollLeft >= maxScroll - 4) {
        track.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        track.scrollBy({ left: itemStep(), behavior: "smooth" });
      }
    }

    function startAuto() {
      if (autoTimer || !needsCarousel()) return;
      autoTimer = setInterval(scrollNext, 4500);
    }

    function stopAuto() {
      clearInterval(autoTimer);
      autoTimer = null;
    }

    function resetAuto() {
      stopAuto();
      updateTrackState();
      if (needsCarousel()) startAuto();
    }

    track.addEventListener("mouseenter", stopAuto);
    track.addEventListener("mouseleave", startAuto);
    track.addEventListener("touchstart", stopAuto, { passive: true });
    track.addEventListener("touchend", function () { setTimeout(startAuto, 2000); }, { passive: true });
    window.addEventListener("resize", resetAuto);

    updateTrackState();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        updateTrackState();
        if (needsCarousel()) startAuto();
      });
    });
  });

  /* ---------------------------------------------- Mobile nav (collapse) */
  var toggle = document.querySelector(".nav-toggle");
  var navBar = document.querySelector(".navbar-cosmo");
  if (toggle && navBar) {
    toggle.addEventListener("click", function () {
      var links = document.querySelector(".nav-links");
      if (!links) return;
      var open = links.style.display === "flex";
      toggle.classList.toggle("is-open", !open);
      links.style.display = open ? "" : "flex";
      links.style.flexDirection = "column";
      links.style.position = "absolute";
      links.style.top = "100%";
      links.style.left = "0";
      links.style.right = "0";
      links.style.background = "#fff";
      links.style.padding = "20px 28px";
      links.style.borderRadius = "22px";
      links.style.marginTop = "8px";
      links.style.boxShadow = "0 12px 30px rgba(0,0,0,.12)";
      links.style.alignItems = "flex-start";
      links.style.gap = "16px";
      links.style.zIndex = "40";
    });
    navBar.style.position = "relative";
  }

  /* --------------------------------------------- Scroll reveal + bars */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add("is-in");
        // animate any snapshot bars inside
        en.target.querySelectorAll("[data-bar]").forEach(function (bar) {
          bar.style.width = bar.getAttribute("data-bar") + "%";
        });
        io.unobserve(en.target);
      }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });

  document.querySelectorAll(".reveal, .reveal-left, .reveal-right, .reveal-scale").forEach(function (el) { io.observe(el); });

  // animate snapshot bars even if their container isn't a .reveal
  var snap = document.querySelector(".rev-summary");
  if (snap) io.observe(snap);

  // Safety fallback: if IntersectionObserver never fires (e.g. offscreen
  // render contexts), force everything visible so content is never stuck hidden.
  setTimeout(function () {
    document.querySelectorAll(".reveal:not(.is-in), .reveal-left:not(.is-in), .reveal-right:not(.is-in), .reveal-scale:not(.is-in)").forEach(function (el) { el.classList.add("is-in"); });
    document.querySelectorAll("[data-bar]").forEach(function (bar) { bar.style.width = bar.getAttribute("data-bar") + "%"; });
  }, 1600);

  /* ---------------------------------------------- Scroll progress bar */
  var progressBar = document.createElement("div");
  progressBar.className = "scroll-progress-bar";
  document.body.prepend(progressBar);

  /* ------------------------------------------ Parallax on scroll */
  var parallaxCfg = [
    { sel: ".gd-tall img",        factor: -0.05 },
    { sel: ".gd-wide img",        factor:  0.06 },
    { sel: ".showcase__map-img",  factor: -0.06 },
    { sel: ".faq-photo img",      factor: -0.07 },
  ];
  var parallaxItems = parallaxCfg.map(function (c) {
    return { el: document.querySelector(c.sel), factor: c.factor };
  }).filter(function (p) { return p.el; });

  var rafPending = false;
  function onScrollFrame() {
    var scrollY = window.scrollY;
    var winH   = window.innerHeight;
    var docH   = document.documentElement.scrollHeight - winH;

    progressBar.style.width = (docH > 0 ? (scrollY / docH) * 100 : 0) + "%";

    parallaxItems.forEach(function (p) {
      var rect       = p.el.getBoundingClientRect();
      var fromCenter = rect.top + rect.height / 2 - winH / 2;
      p.el.style.transform = "translateY(" + (fromCenter * p.factor).toFixed(2) + "px)";
    });

    rafPending = false;
  }

  window.addEventListener("scroll", function () {
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(onScrollFrame);
    }
  }, { passive: true });

  onScrollFrame();

  // Video play/pause toggle
  var videoBox = document.getElementById("videoBox");
  var setupVideo = document.getElementById("setupVideo");
  var videoPlayBtn = document.getElementById("videoPlayBtn");

  if (videoPlayBtn && setupVideo) {
    videoPlayBtn.addEventListener("click", function () {
      if (setupVideo.paused) {
        setupVideo.play();
        videoBox.classList.add("is-playing");
      } else {
        setupVideo.pause();
        videoBox.classList.remove("is-playing");
      }
    });

    setupVideo.addEventListener("ended", function () {
      videoBox.classList.remove("is-playing");
    });
  }

  // Compare table column selector (mobile) — handled via document click delegation above.

})();
